import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {ResetPasswordViewComponent} from './views/reset-password/reset-password-view.component';
import {SetPasswordViewComponent} from './views/set-password/set-password-view.component';
import {SetPasswordSuccessViewComponent} from './views/set-password-success/set-password-success-view.component';
import {ResetPasswordSuccessViewComponent} from './views/reset-password-success/reset-password-success-view.component';
import {PasswordManagementComponent} from './password-management.component';

const routes: Routes = [
    {
        path: '',
        component: PasswordManagementComponent,
        children: [

            {
                path: 'users/:username/request-password-reset',
                component: ResetPasswordViewComponent
            },
            {
                path: 'request-password-reset-success',
                component: ResetPasswordSuccessViewComponent
            },
            {
                path: 'users/:username/set-password-using-token/:token',
                component: SetPasswordViewComponent
            },
            {
                path: 'set-password-success',
                component: SetPasswordSuccessViewComponent
            }
        ]
    }
];

@NgModule({
    imports: [
        RouterModule.forChild(routes)
    ],
    declarations: []
})
export class PasswordManagementRoutingModule { }
